import axios from "./axios"

export default {

    get(params, callback) {
        axios.get("/cartscanlog", { params: params }).then(res => {
            callback(res.data)
        })
    }
}